import { PaymentTerm } from "@faire/web-api/indigofair/data/PaymentTerm";
export var orderTermIsNet60 = function orderTermIsNet60(brandOrder) {
  var _brandOrder$brand_ord;
  var paymentTerm = (_brandOrder$brand_ord = brandOrder.brand_order) === null || _brandOrder$brand_ord === void 0 ? void 0 : _brandOrder$brand_ord.payment_term;
  var isNet60 = paymentTerm === PaymentTerm.NET60;
  var isNet60OnFirstOrder = paymentTerm === PaymentTerm.NET60_ON_FIRST_ORDER;
  return isNet60 || isNet60OnFirstOrder;
};